import { RuntimeException1r3t0zl97011n as RuntimeException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloExceptionClass;
function ApolloException() {
  if (ApolloExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static f4h(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.qd(message, cause);
        captureStack($this, $this.e4h_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloException');
    ApolloExceptionClass = $;
  }
  return ApolloExceptionClass;
}
var ApolloOfflineExceptionClass;
function ApolloOfflineException() {
  if (ApolloOfflineExceptionClass === VOID) {
    class $ extends ApolloException() {
      static k4h() {
        var $this = this.f4h('The device is offline');
        captureStack($this, $this.j4h_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloOfflineException', $.k4h);
    ApolloOfflineExceptionClass = $;
  }
  return ApolloOfflineExceptionClass;
}
var ApolloNetworkExceptionClass;
function ApolloNetworkException() {
  if (ApolloNetworkExceptionClass === VOID) {
    class $ extends ApolloException() {
      static b4b(message, platformCause) {
        message = message === VOID ? null : message;
        platformCause = platformCause === VOID ? null : platformCause;
        var $this = this.f4h(message, platformCause instanceof Error ? platformCause : null);
        captureStack($this, $this.a4b_1);
        $this.z4a_1 = platformCause;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloNetworkException', $.b4b);
    ApolloNetworkExceptionClass = $;
  }
  return ApolloNetworkExceptionClass;
}
var ApolloWebSocketClosedExceptionClass;
function ApolloWebSocketClosedException() {
  if (ApolloWebSocketClosedExceptionClass === VOID) {
    class $ extends ApolloException() {
      static r4h(code, reason, cause) {
        reason = reason === VOID ? null : reason;
        cause = cause === VOID ? null : cause;
        var $this = this.f4h("WebSocket Closed code='" + code + "' reason='" + reason + "'", cause);
        captureStack($this, $this.q4h_1);
        $this.o4h_1 = code;
        $this.p4h_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloWebSocketClosedException');
    ApolloWebSocketClosedExceptionClass = $;
  }
  return ApolloWebSocketClosedExceptionClass;
}
var ApolloGraphQLExceptionClass;
function ApolloGraphQLException() {
  if (ApolloGraphQLExceptionClass === VOID) {
    class $ extends ApolloException() {
      static u46(error) {
        var $this = this.f4h("GraphQL error: '" + error.g4a_1 + "'");
        captureStack($this, $this.t46_1);
        $this.r46_1 = error;
        $this.s46_1 = listOf($this.r46_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloGraphQLException');
    ApolloGraphQLExceptionClass = $;
  }
  return ApolloGraphQLExceptionClass;
}
var DefaultApolloExceptionClass;
function DefaultApolloException() {
  if (DefaultApolloExceptionClass === VOID) {
    class $ extends ApolloException() {
      static n46(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.f4h(message, cause);
        captureStack($this, $this.m46_1);
        return $this;
      }
    }
    initMetadataForClass($, 'DefaultApolloException', $.n46);
    DefaultApolloExceptionClass = $;
  }
  return DefaultApolloExceptionClass;
}
var NoDataExceptionClass;
function NoDataException() {
  if (NoDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      static a47(cause) {
        var $this = this.f4h('No data was found', cause);
        captureStack($this, $this.z46_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NoDataException');
    NoDataExceptionClass = $;
  }
  return NoDataExceptionClass;
}
var ApolloHttpExceptionClass;
function ApolloHttpException() {
  if (ApolloHttpExceptionClass === VOID) {
    class $ extends ApolloException() {
      static z4h(statusCode, headers, body, message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.f4h(message, cause);
        captureStack($this, $this.y4h_1);
        $this.v4h_1 = statusCode;
        $this.w4h_1 = headers;
        $this.x4h_1 = body;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloHttpException');
    ApolloHttpExceptionClass = $;
  }
  return ApolloHttpExceptionClass;
}
var RouterErrorClass;
function RouterError() {
  if (RouterErrorClass === VOID) {
    class $ extends ApolloException() {
      static f4i(errors) {
        var tmp0_safe_receiver = firstOrNull(errors);
        var $this = this.f4h("Router error(s) (first: '" + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g4a_1) + "')");
        captureStack($this, $this.e4i_1);
        $this.d4i_1 = errors;
        return $this;
      }
    }
    initMetadataForClass($, 'RouterError');
    RouterErrorClass = $;
  }
  return RouterErrorClass;
}
var SubscriptionOperationExceptionClass;
function SubscriptionOperationException() {
  if (SubscriptionOperationExceptionClass === VOID) {
    class $ extends ApolloException() {
      static l4i(operationName, payload) {
        var $this = this.f4h('Operation error ' + operationName);
        captureStack($this, $this.k4i_1);
        $this.j4i_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionOperationException');
    SubscriptionOperationExceptionClass = $;
  }
  return SubscriptionOperationExceptionClass;
}
var JsonDataExceptionClass;
function JsonDataException() {
  if (JsonDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      static v4a(message) {
        var $this = this.f4h(message);
        captureStack($this, $this.u4a_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDataException');
    JsonDataExceptionClass = $;
  }
  return JsonDataExceptionClass;
}
var SubscriptionConnectionExceptionClass;
function SubscriptionConnectionException() {
  if (SubscriptionConnectionExceptionClass === VOID) {
    class $ extends ApolloException() {
      static r4i(payload) {
        var $this = this.f4h('Subscription connection error');
        captureStack($this, $this.q4i_1);
        $this.p4i_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionConnectionException');
    SubscriptionConnectionExceptionClass = $;
  }
  return SubscriptionConnectionExceptionClass;
}
var NullOrMissingFieldClass;
function NullOrMissingField() {
  if (NullOrMissingFieldClass === VOID) {
    class $ extends ApolloException() {
      static f47(message) {
        var $this = this.f4h(message);
        captureStack($this, $this.e47_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NullOrMissingField');
    NullOrMissingFieldClass = $;
  }
  return NullOrMissingFieldClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends ApolloException() {
      static k4g(message) {
        var $this = this.f4h(message);
        captureStack($this, $this.j4g_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
//region block: exports
export {
  ApolloException as ApolloException16lek20l78zc3,
  ApolloGraphQLException as ApolloGraphQLException2qazyzs4ebcad,
  ApolloHttpException as ApolloHttpException3o30u8ntkffuh,
  ApolloNetworkException as ApolloNetworkException3denf70pfh242,
  ApolloOfflineException as ApolloOfflineException3onq1f2zlyouj,
  ApolloWebSocketClosedException as ApolloWebSocketClosedException26hvn543pf46i,
  DefaultApolloException as DefaultApolloException8w3ielfxng0h,
  JsonDataException as JsonDataException2rdtm884tky1l,
  JsonEncodingException as JsonEncodingException1gbe1fu68vssf,
  NoDataException as NoDataException34qvcinicy2ih,
  NullOrMissingField as NullOrMissingField1bkks6typ2v8h,
  RouterError as RouterError3i6hxcnqsy5l3,
  SubscriptionConnectionException as SubscriptionConnectionException12fjxvnnqzby5,
  SubscriptionOperationException as SubscriptionOperationException3t8cqqpx8bt9j,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
